import moment from 'moment';
import {
  SERVICES_ERROR,
  SERVICES_REQUEST,
  SERVICES_SUCCESS,
  SERVICES_STATUS_UPDATE,
  SERVICES_SET_FILTERS,
} from './types';

const initialState = {
  data: {
    services: [],
    total   : 0,
  },
  error  : null,
  filters: {
    from: moment()
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .valueOf(),
    to: moment()
      .hours(23)
      .minutes(59)
      .seconds(59)
      .milliseconds(0)
      .valueOf(),
  },
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SERVICES_ERROR:
      return {
        ...state,
        error  : action.error,
        loading: false,
      };
    case SERVICES_REQUEST:
      return {
        ...state,
        error  : null,
        loading: true,
      };
    case SERVICES_SUCCESS:
      return {
        ...state,
        data   : action.data,
        loading: false,
      };
    case SERVICES_STATUS_UPDATE:
      return {
        ...state,
        data: {
          ...state.data,
          services: state.data.services.map((item) => {
            // eslint-disable-next-line no-underscore-dangle
            if (item._id !== action.data._id) {
              return item;
            }
            return {
              ...item,
              ...(action.data && {
                agent : action.data.agent,
                status: action.data.status,
                paxs  : action.data.paxs,
                log   : action.data.log,
              }),
            };
          }),
        },
        loading: false,
      };
    case SERVICES_SET_FILTERS:
      return {
        ...state,
        filters: action.filters,
      };
    default:
      return state;
  }
}
